module.exports = __webpack_public_path__ + "static/media/imex.e900eabf.png";